import React from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

import I18n from "../i18n.js";
import PercentFormatter from "../../utils/percent_formatter.js";

const blockStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.grayBg,
    display: "flex",
    padding: "16px 0",
    fontWeight: theme.typography.fontWeightMedium,
    ['@media (max-width: 768px)']: {
      padding: "8px 0",
    },
  },
  column: {
    flex: "0 1 50%",
    padding: "6px 0",
    textAlign: "center",
    "& + &": {
      borderLeft: `1px solid ${theme.palette.grayText}`
    },
    ['@media (max-width: 768px)']: {
      padding: "0px 0",
    },
  },
  value: {
    fontSize: "28px",
    lineHeight: "1.3",
    margin: "0 0 12px",
    ['@media (max-width: 768px)']: {
      fontSize: "17px",
      lineHeight: "22px",
      margin: "0 0 5px",
    },
  },
  label: {
    fontSize: "18px",
    lineHeight: "1.3",
    margin: "0",
    ['@media (max-width: 768px)']: {
      fontSize: "11px",
      lineHeight: "16px",
    },
  }
}));

/**
 * Display info of project about period and revenue
 * @name RevenueAndPeriodBlock
 * @param {object} props React component properties
 * @param {string} [props.className] CSS-class of container
 * @param {object} [props.project] Project info from API
 * @example
 * const project = projects[0];
 * return (
 *  <RevenueAndPeriodBlock className = { "class-name" } 
 *                         project = { project } />
 * )
*/

const RevenueAndPeriodBlock =  (props) => {

  const classes = blockStyles();
  const { className, project = {} } = props;
  const { annualInterestRate, executionTimeFrom, executionTimeTo } = project;
  if(!executionTimeFrom && (!executionTimeFrom || !executionTimeTo)) {
    return (null);
  }
  return (
    <div className = { clsx(classes.root, className) } >
      <div className = { classes.column }>
        {
          annualInterestRate && 
          <React.Fragment>
            <div className = { classes.value } >
              { PercentFormatter.format(annualInterestRate / 100, "0.00 %") }
            </div>
            <div className = { classes.label } >
              { I18n.t("shared.revenue") }
            </div>
          </React.Fragment>
        }
      </div>
      <div className = { classes.column } >
        {
          executionTimeFrom && executionTimeTo &&
          <React.Fragment>
            <div className = { classes.value } >
              { `${project.executionTimeFrom}-${project.executionTimeTo}` }
            </div>
            <div className = { classes.label } >
              { I18n.t("shared.month") }
            </div>
          </React.Fragment>
        }
      </div>
    </div>
  );
}

export default RevenueAndPeriodBlock;